/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CategoryStatisticsDto model module.
 * @module model/CategoryStatisticsDto
 * @version v0
 */
class CategoryStatisticsDto {
    /**
     * Constructs a new <code>CategoryStatisticsDto</code>.
     * @alias module:model/CategoryStatisticsDto
     */
    constructor() { 
        
        CategoryStatisticsDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CategoryStatisticsDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CategoryStatisticsDto} obj Optional instance to populate.
     * @return {module:model/CategoryStatisticsDto} The populated <code>CategoryStatisticsDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CategoryStatisticsDto();

            if (data.hasOwnProperty('sessionType')) {
                obj['sessionType'] = ApiClient.convertToType(data['sessionType'], 'String');
            }
            if (data.hasOwnProperty('totalSessions')) {
                obj['totalSessions'] = ApiClient.convertToType(data['totalSessions'], 'Number');
            }
            if (data.hasOwnProperty('completedSessions')) {
                obj['completedSessions'] = ApiClient.convertToType(data['completedSessions'], 'Number');
            }
            if (data.hasOwnProperty('activeSessions')) {
                obj['activeSessions'] = ApiClient.convertToType(data['activeSessions'], 'Number');
            }
            if (data.hasOwnProperty('totalPagesVisited')) {
                obj['totalPagesVisited'] = ApiClient.convertToType(data['totalPagesVisited'], 'Number');
            }
            if (data.hasOwnProperty('totalQuestionsAnswered')) {
                obj['totalQuestionsAnswered'] = ApiClient.convertToType(data['totalQuestionsAnswered'], 'Number');
            }
            if (data.hasOwnProperty('totalCorrectAnswers')) {
                obj['totalCorrectAnswers'] = ApiClient.convertToType(data['totalCorrectAnswers'], 'Number');
            }
            if (data.hasOwnProperty('accuracyRate')) {
                obj['accuracyRate'] = ApiClient.convertToType(data['accuracyRate'], 'Number');
            }
            if (data.hasOwnProperty('totalTimeMinutes')) {
                obj['totalTimeMinutes'] = ApiClient.convertToType(data['totalTimeMinutes'], 'Number');
            }
            if (data.hasOwnProperty('averageTimePerSessionMinutes')) {
                obj['averageTimePerSessionMinutes'] = ApiClient.convertToType(data['averageTimePerSessionMinutes'], 'Number');
            }
            if (data.hasOwnProperty('firstActivity')) {
                obj['firstActivity'] = ApiClient.convertToType(data['firstActivity'], 'Date');
            }
            if (data.hasOwnProperty('lastActivity')) {
                obj['lastActivity'] = ApiClient.convertToType(data['lastActivity'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CategoryStatisticsDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CategoryStatisticsDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['sessionType'] && !(typeof data['sessionType'] === 'string' || data['sessionType'] instanceof String)) {
            throw new Error("Expected the field `sessionType` to be a primitive type in the JSON string but got " + data['sessionType']);
        }

        return true;
    }


}



/**
 * @member {String} sessionType
 */
CategoryStatisticsDto.prototype['sessionType'] = undefined;

/**
 * @member {Number} totalSessions
 */
CategoryStatisticsDto.prototype['totalSessions'] = undefined;

/**
 * @member {Number} completedSessions
 */
CategoryStatisticsDto.prototype['completedSessions'] = undefined;

/**
 * @member {Number} activeSessions
 */
CategoryStatisticsDto.prototype['activeSessions'] = undefined;

/**
 * @member {Number} totalPagesVisited
 */
CategoryStatisticsDto.prototype['totalPagesVisited'] = undefined;

/**
 * @member {Number} totalQuestionsAnswered
 */
CategoryStatisticsDto.prototype['totalQuestionsAnswered'] = undefined;

/**
 * @member {Number} totalCorrectAnswers
 */
CategoryStatisticsDto.prototype['totalCorrectAnswers'] = undefined;

/**
 * @member {Number} accuracyRate
 */
CategoryStatisticsDto.prototype['accuracyRate'] = undefined;

/**
 * @member {Number} totalTimeMinutes
 */
CategoryStatisticsDto.prototype['totalTimeMinutes'] = undefined;

/**
 * @member {Number} averageTimePerSessionMinutes
 */
CategoryStatisticsDto.prototype['averageTimePerSessionMinutes'] = undefined;

/**
 * @member {Date} firstActivity
 */
CategoryStatisticsDto.prototype['firstActivity'] = undefined;

/**
 * @member {Date} lastActivity
 */
CategoryStatisticsDto.prototype['lastActivity'] = undefined;






export default CategoryStatisticsDto;

